
export const API_CLIENT_ID_RESPONSE_SUCCESS = "API_CLIENT_ID_RESPONSE_SUCCESS";
export const API_CLIENT_ID_ERROR = "API_CLIENT_ID_ERROR";
export const GET_CLIENT_ID = "GET_CLIENT_ID";
